export default __webpack_public_path__ + "static/media/logo-header.f0e310a5.svg";